import React from "react";
import LoungeProductCard from "../components/loungeproductpage-components/LoungeProductCard";
import "../styles.css";

const LoungeProducts = () => {
  return (
    <div className="page-content">
      <h2>Product Ranges</h2>
      <LoungeProductCard />
    </div>
  );
};

export default LoungeProducts;
